/* Outdoors Nordic. Flyttad ur snippets/on-bundle-builder-body.liquid 2026-10-07.
   Lag inline och skickades med varje sidvisning som anvande sektionen.
   Laddas som modul: samma URL evalueras en gang oavsett antal taggar. */

  (function () {
if (window.__onBbInit) return;
window.__onBbInit = true;
/* Butiken visar priser utan decimaler. Samma strip som resten av temat: ta
bort en avslutande tvasiffrig decimalgrupp, oavsett komma eller punkt. */
function strip(m) { return (m || '').replace(/([.,])\d{2}(?=\D|$)/g, ''); }
/* Laser av butikens prisformat ur ett FARDIGRENDERAT exempel i stallet for
att tolka money_format. Monstret ljuger: amount_no_decimals ger komma som
tusentalstecken i Shopifys egen dokumentation, medan butiken faktiskt
skriver ut mellanslag. Exemplet ar hur priset SER UT pa sidan, och det ar
det enda som raknas nar totalen ska sta bredvid styckpriserna. */
function gorPengar(exempel) {
var txt = exempel || '1,234,568';
// Sifferdelen: siffror plus de tecken som kan skilja grupper at.
var m = txt.match(/[\d][\d\s.,'\u00a0]*[\d]|[\d]/);
var sifferdel = m ? m[0] : txt;
var prefix = txt.slice(0, txt.indexOf(sifferdel));
var suffix = txt.slice(txt.indexOf(sifferdel) + sifferdel.length);
// Avgransaren ar det forsta icke-siffertecknet inuti sifferdelen.
var sm = sifferdel.match(/\d([^\d])\d/);
var sep = sm ? sm[1] : '';
return function (cent) {
var hel = Math.round(cent / 100);
var ut = String(hel);
if (sep) ut = ut.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
return strip(prefix + ut + suffix);
};
}
function init(root) {
if (!root || root.dataset.bbReady === '1') return;
root.dataset.bbReady = '1';
var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 3;
var pengar = gorPengar(root.getAttribute('data-money-sample'));
var tiers = [];
try { tiers = JSON.parse(root.getAttribute('data-tiers') || '[]') || []; } catch (e) { tiers = []; }
tiers.sort(function (a, b) { return a.qty - b.qty; });
var tSold = root.getAttribute('data-t-soldout') || 'Sold out';
var tRemove = root.getAttribute('data-t-remove') || 'Remove';
var tSave = root.getAttribute('data-t-save') || 'You save';
var tAddMore = root.getAttribute('data-t-addmore') || '';
var listEl = root.querySelector('[data-bb-list]');
var moreEl = root.querySelector('[data-bb-more]');
var emptyEl = root.querySelector('[data-bb-empty]');
var cartEl = root.querySelector('[data-bb-cart]');
var pickedEl = root.querySelector('[data-bb-picked]');
var nudgeEl = root.querySelector('[data-bb-nudge]');
var wasEl = root.querySelector('[data-bb-was]');
var nowEl = root.querySelector('[data-bb-now]');
var atcEl = root.querySelector('[data-bb-atc]');
var catEl = root.querySelector('[data-bb-cat]');
var kort = [].slice.call(root.querySelectorAll('[data-bb-card]'));
kort.forEach(function (k) {
var sc = k.querySelector('[data-bb-variants]');
/* HELA lasningen ligger i try. Forsta versionen av normaliseringen lade
   getAttribute UTANFOR, och da kastade ett kort utan script-tagg TypeError
   som avbrot hela init och dodade byggaren. Snippeten renderar alltid taggen,
   sa det var osannolikt - men skyddet som fanns forsvann, och det ar precis
   sadant som bara syns den dag markupen andras. */
try {
  k._varianter = JSON.parse(sc.textContent);
  var kortP = parseInt(sc.getAttribute('data-p') || '0', 10);
  var kortM = sc.getAttribute('data-m') || '';
  k._varianter.forEach(function (v) {
    if (v.t === undefined) v.t = (v.o || []).join(' / ');
    v.a = v.a === undefined ? true : !!v.a;
    if (v.p === undefined) v.p = kortP;
    if (v.m === undefined) v.m = kortM;
  });
} catch (e) { k._varianter = []; }

});
var filterKon = '';
var filterTyp = '';
var synliga = perPage;
var valda = [];
function traffar() {
return kort.filter(function (k) {
  var g = k.getAttribute('data-gender') || '';
  var t = k.getAttribute('data-type') || '';
  if (filterKon && (' ' + g + ' ').indexOf(' ' + filterKon + ' ') < 0) return false;
  if (filterTyp && t !== filterTyp) return false;
  return true;
});
}
function rita() {
var t = traffar();
kort.forEach(function (k) { k.hidden = true; });
t.slice(0, synliga).forEach(function (k) { k.hidden = false; });
moreEl.hidden = t.length <= synliga;
emptyEl.hidden = t.length > 0;
}
/* Valjer variant ur produktens egna varianter genom att matcha ALLA
 optionsvarden. Titelmatchning hade brustit sa fort ett varde innehaller
 ett snedstreck. */
function valdVariant(k) {
var selects = [].slice.call(k.querySelectorAll('[data-bb-opt]'));
var v = k._varianter || [];
if (!selects.length) return v[0] || null;
var vill = selects.map(function (s) { return s.value; });
for (var i = 0; i < v.length; i++) {
  var o = v[i].o || [];
  var ok = true;
  for (var j = 0; j < vill.length; j++) { if (o[j] !== vill[j]) { ok = false; break; } }
  if (ok) return v[i];
}
return null;
}
function uppdateraKort(k) {
var v = valdVariant(k);
var add = k.querySelector('[data-bb-add]');
var so = k.querySelector('[data-bb-soldout]');
var pr = k.querySelector('[data-bb-price]');
var finns = !!(v && v.a);
add.disabled = !finns;
so.hidden = finns;
if (!finns) so.textContent = tSold;
if (v && v.m && pr) pr.textContent = v.m;
}
function rabattPct(antal) {
var pct = 0;
for (var i = 0; i < tiers.length; i++) { if (antal >= tiers[i].qty) pct = tiers[i].pct; }
return pct;
}
function nastaTier(antal) {
for (var i = 0; i < tiers.length; i++) { if (antal < tiers[i].qty) return tiers[i]; }
return null;
}
function ritaKorg() {
cartEl.hidden = valda.length === 0;
pickedEl.innerHTML = '';
var brutto = 0;
valda.forEach(function (rad, i) {
  brutto += rad.pris;
  var li = document.createElement('li');
  li.className = 'on-bb__row';
  var namn = document.createElement('span');
  namn.className = 'on-bb__row-name';
  namn.textContent = rad.titel;
  if (rad.variant && rad.variant !== 'Default Title') {
    var vs = document.createElement('span');
    vs.className = 'on-bb__row-var';
    vs.textContent = ' · ' + rad.variant;
    namn.appendChild(vs);
  }
  var pris = document.createElement('span');
  pris.textContent = pengar(rad.pris);
  var x = document.createElement('button');
  x.type = 'button';
  x.className = 'on-bb__row-x';
  x.textContent = tRemove;
  x.addEventListener('click', function () { valda.splice(i, 1); ritaKorg(); });
  li.appendChild(namn); li.appendChild(pris); li.appendChild(x);
  pickedEl.appendChild(li);
});
 /* Omgång 92: tillbehör (data-qx) räknas inte in och får ingen mängdrabatt, som kassan. */
var antalR = valda.filter(function (r) { return !r.x; }).length;
var bruttoR = valda.reduce(function (a, r) { return a + (r.x ? 0 : r.pris); }, 0);
var pct = rabattPct(antalR);
var netto = brutto - Math.round(bruttoR * pct / 100);
nowEl.textContent = pengar(netto);
if (pct > 0) { wasEl.hidden = false; wasEl.textContent = pengar(brutto); }
else { wasEl.hidden = true; }
 var nasta = nastaTier(antalR);
if (nasta && valda.length > 0) {
  var kvar = nasta.qty - antalR;
  nudgeEl.hidden = false;
  nudgeEl.textContent = tAddMore.replace(/\d+/, String(kvar)) + ' ' + nasta.pct + ' %';
} else if (pct > 0) {
  nudgeEl.hidden = false;
  nudgeEl.textContent = tSave + ' ' + pengar(brutto - netto) + ' (' + pct + ' %)';
} else {
  nudgeEl.hidden = true;
}
atcEl.disabled = valda.length === 0;
}
root.querySelectorAll('[data-bb-gender]').forEach(function (b) {
b.addEventListener('click', function () {
  root.querySelectorAll('[data-bb-gender]').forEach(function (o) { o.classList.remove('is-on'); });
  b.classList.add('is-on');
  filterKon = b.getAttribute('data-bb-gender') || '';
  synliga = perPage;
  rita();
});
});
if (catEl) {
catEl.addEventListener('change', function () {
  filterTyp = catEl.value || '';
  synliga = perPage;
  rita();
});
}
root.querySelectorAll('[data-bb-type]').forEach(function (b) {
b.addEventListener('click', function () {
  root.querySelectorAll('[data-bb-type]').forEach(function (o) { o.classList.remove('is-on'); });
  b.classList.add('is-on');
  filterTyp = b.getAttribute('data-bb-type') || '';
  synliga = perPage;
  rita();
});
});
moreEl.addEventListener('click', function () { synliga += perPage; rita(); });
listEl.addEventListener('change', function (e) {
var k = e.target.closest('[data-bb-card]');
if (k) uppdateraKort(k);
});
listEl.addEventListener('click', function (e) {
var add = e.target.closest('[data-bb-add]');
if (!add) return;
var k = add.closest('[data-bb-card]');
var v = valdVariant(k);
if (!v || !v.a) return;
valda.push({ id: v.id, titel: k.getAttribute('data-title'), variant: v.t, pris: v.p, x: k.hasAttribute('data-qx') });
ritaKorg();
add.classList.add('is-added');
setTimeout(function () { add.classList.remove('is-added'); }, 700);
});
atcEl.addEventListener('click', function () {
if (!valda.length) return;
atcEl.disabled = true;
var items = valda.map(function (r) { return { id: r.id, quantity: 1 }; });
var body = { items: items };
var cic = document.querySelector('cart-items-component');
var sid = cic ? (cic.getAttribute('section-id') || cic.getAttribute('data-section-id')) : null;
if (sid) { body.sections = sid; body.sections_url = window.location.pathname; }
 fetch('/cart/add.js', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
  body: JSON.stringify(body)
})
  .then(function (r) { return r.json(); })
  .then(function (added) {
    if (added && added.status && added.status >= 400) throw new Error('add failed');
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { oppnaLadan(cart, added.sections); });
  })
  .catch(function () { window.location.href = '/cart'; })
  .then(function () { atcEl.disabled = false; });
});
/* Samma vag som on-bundle: cart:update ar Horizons egen handelse och maste
 bara med detail.data, annars uppdateras varken bubblan eller ladan. */
function oppnaLadan(cart, sections) {
var detail = { resource: cart, sourceId: 'on-bb', data: { source: 'on-bb', itemCount: cart.item_count, sections: sections } };
try { if (window.onPopupGate) window.onPopupGate.block('cart'); } catch (e) {}
try { document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: detail })); } catch (e) {}
var drawer = document.querySelector('cart-drawer-component');
if (!drawer) { window.location.href = '/cart'; return; }
try { if (typeof drawer.open === 'function') drawer.open(); } catch (e) {}
setTimeout(function () {
  var dlg = drawer.querySelector('dialog');
  if (dlg && !dlg.open) { try { dlg.showModal(); } catch (e) { window.location.href = '/cart'; } }
}, 350);
}
kort.forEach(uppdateraKort);
rita();
ritaKorg();
}
function initAll(scope) {
(scope || document).querySelectorAll('[data-on-bb]').forEach(init);
}
if (document.readyState !== 'loading') initAll(document);
else document.addEventListener('DOMContentLoaded', function () { initAll(document); });
document.addEventListener('shopify:section:load', function (e) { initAll(e.target || document); });
  })();

